<template>
  <div>
    <list-page-header />
    <yv-index
      :path="path"
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :disabledHeaderActions="true"
      :sortable="sortable"
      :sort-data="sortData"
      :tableActionsComponent="TableActions"
      ref="rolesTable"
      :additionalParams="{ is_mutable: true }"
    >
    </yv-index>
  </div>
</template>

<script>
import { YvIndex } from "@/components/Base";
import { service_paths, service_names } from "@/constants/Services";
import Header from "./Header";
import TableActions from "./TableActions.vue";
import Swal from "sweetalert2";
import { Message } from "@/helpers/utils";
export default {
  name: "ListPage",
  components: { YvIndex, ListPageHeader: Header },
  data() {
    const self = this;
    return {
      gradeList: [],
      TableActions,
      formSearch: [
        {
          label: "setting.role_name",
          name: "name__~",
          value: "",
          type: "input"
        },
        {
          label: "common.status",
          name: "status",
          value: "",
          type: "select",
          options: [
            {
              id: "",
              name: "common.all"
            },
            {
              id: "Active",
              name: "common.active"
            },
            {
              id: "Inactive",
              name: "common.inactive"
            }
          ]
        }
      ],
      path: service_paths.roles,
      columns: {
        name: "setting.role_name",
        count_user: "setting.total_user",
        status: "common.status"
      },
      sortable: ["name", "status"],
      sortData: {
        currentSort: "id",
        currentSortOrder: "desc"
      }
    };
  },
  methods: {
    reFetchTableData() {
      return this.$refs.rolesTable.getTableData();
    },
    //delete
    async delete(data) {
      const id = data.id || data._id;
      await this.$axios
        .delete(this.path + "/" + id)
        .then(async () => {
          await this.reFetchTableData();
          Message.success(this.$t("common.delete_success"));
        })
        .catch(error => {
          console.log(error);
        });
    },
    confirmDelete(data) {
      Swal.fire({
        title: this.$t("common.confirmation"),
        text: this.$t("setting.deleted_role_cant_be_recovered"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-danger btn-fill",
        cancelButtonClass: "md-button md-secondary btn-fill",
        confirmButtonText: this.$t("common.delete"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.delete(data);
        }
      });
    }
  },
  provide() {
    return {
      confirmDelete: this.confirmDelete
    };
  }
};
</script>

<style lang="scss" scoped></style>
